import React from "react";
import { Box } from "@mui/material";
import { useResponsive } from "@kivunova/kivufrontendcommon";
import { useActionBarHeight } from "./useActionBarHeight";

export interface ModalFooterActionBarProps {
  children: React.ReactNode;
  sx?: React.ComponentProps<typeof Box>["sx"];
}

/**
 * ModalFooterActionBar - Action bar specifically for modal footers
 * Stacks vertically on mobile, horizontal reversed on desktop
 * Includes top border and proper spacing for modal footer context
 */
const ModalFooterActionBar: React.FC<ModalFooterActionBarProps> = ({
  children,
  sx
}) => {
  const { isMobile } = useResponsive();
  const minH = useActionBarHeight();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row-reverse",
        gap: isMobile ? 1 : 1.5,
        width: "100%",
        pt: 2.5,
        mt: 1,
        borderTop: "1px solid",
        borderColor: "divider",
        flexShrink: 0,
        "& > *": {
          width: isMobile ? "100% !important" : "auto",
          minHeight: minH,
          flexShrink: 0
        },
        ...sx
      }}
    >
      {children}
    </Box>
  );
};

export default ModalFooterActionBar;
